var _CUSTOM_COD_FORM_PROVINCES = {
  data: {"Minas Gerais":{"Belo Horizonte":true,"Ibirité":true,"Sabará":true,"Santa Luzia":true,"Confins":true,"Betim":true,"Contagem":true},"Paraná":{"Almirante Tamandaré":true,"Araucária":true,"Colombo":true,"Curitiba":true,"Fazenda Rio Grande":true,"Pinhais":true,"Piraquara":true,"São José dos Pinhais":true},"Goiás":{"Aparecida de Goiânia":true,"Goiânia":true,"Trindade":true,"Senador Canedo":true,"Goianira":true,"Anápolis":true,"Aragoiânia":true,"Bonfinópolis":true,"Brazabrantes":true,"Caldazinha":true,"Caturaí":true,"Goianápolis":true,"Guapó":true,"Inhumas":true,"Nerópolis":true,"Nova Veneza":true,"Santo Antônio de Goiás":true,"Terezópolis de Goiás":true,"Hidrolândia":true},"São Paulo":{"Arujá":true,"Barueri":true,"Carapicuíba":true,"Cotia":true,"Diadema":true,"Embu das Artes":true,"Ferraz de Vasconcelos":true,"Guarulhos":true,"Itapevi":true,"Itaquaquecetuba":true,"Jandira":true,"Mauá":true,"Mogi das Cruzes":true,"Osasco":true,"Poá":true,"Santo André":true,"São Bernardo do Campo":true,"São Caetano do Sul":true,"São Paulo":true,"Suzano":true,"Taboão da Serra":true,"Caieiras":true,"Cajamar":true,"Campo Limpo Paulista":true,"Francisco Morato":true,"Franco da Rocha":true,"Jundiaí":true,"Mairiporã":true,"Monte Mor":true,"Valinhos":true,"Vinhedo":true,"Americana":true,"Campinas":true,"Hortolândia":true,"Nova Odessa":true,"Sumaré":true,"Santa Bárbara D'Oeste":true,"Paulínia":true},"Rio De Janeiro":{"Duque de Caxias":true,"Nilópolis":true,"Nova Iguaçu":true,"Rio de Janeiro":true,"São João de Meriti":true,"Niterói":true,"São Gonçalo":true,"Mesquita":true,"Queimados":true,"Belford Roxo":true},"Amazonas":{"Manaus":true},"Rio Grande do Sul":{"Alvorada":true,"Porto Alegre":true,"Cachoeirinha":true,"Canoas":true,"Eldorado do Sul":true,"Esteio":true,"São Leopoldo":true,"Sapucaia do Sul":true,"Gravataí":true,"Guaíba":true,"Novo Hamburgo":true,"Campo Bom":true,"Estância Velha":true,"Sapiranga":true,"Viamão":true},"Ceará":{"Caucaia":true,"Eusébio":true,"Fortaleza":true,"Itaitinga":true,"Maracanaú":true,"Maranguape":true,"Pacatuba":true,"Horizonte":true,"Pacajus":true,"Pindoretama":true},"Bahia":{"Lauro de Freitas":true,"Salvador":true},"Piauí":{"Teresina":true,"Timon":true,"Altos":true,"Demerval Lobão":true},"Maranhão":{"Raposa":true,"São José de Ribamar":true,"São Luís":true,"Paço do Lumiar":true},"Espírito Santo":{"Cariacica":true,"Serra":true,"Vila Velha":true,"Vitória":true,"Viana":true},"Rio Grande do Norte":{"Parnamirim":true,"Extremoz":true,"Macaíba":true,"Natal":true,"São Gonçalo do Amarante":true},"Pernambuco":{"Abreu e Lima":true,"Igarassu":true,"Jaboatão dos Guararapes":true,"Olinda":true,"Paulista":true,"Recife":true,"Cabo de Santo Agostinho":true,"Camaragibe":true,"São Lourenço da Mata":true,"Ilha de Itamaracá":true,"Itapissuma":true},"Distrito Federal":{"Brasília":true,"Gama":true,"Taguatinga":true,"Riacho Fundo":true,"Ceilândia":true,"Samambaia":true,"Recanto das Emas":true,"Santa Maria":true},"Paraíba":{"João Pessoa":true},"Mato Grosso do Sul":{"Campo Grande":true},"Pará":{"Ananindeua":true,"Belém":true,"Marituba":true},"Santa Catarina":{"Balneário Camboriú":true,"Barra Velha":true,"Camboriú":true,"Ilhota":true,"Itajaí":true,"Itapema":true,"Navegantes":true,"Penha":true,"Balneário Piçarras":true}},
  startFields: function () {
    try {
      document.querySelector('#_rsi-cod-form-modal-form [data-type="province_country_field"]').value = "";
      _CUSTOM_COD_FORM_PROVINCES.onProvinceChange();
      document.querySelector('#_rsi-cod-form-modal-form [data-type="province_country_field"]').addEventListener("change", _CUSTOM_COD_FORM_PROVINCES.onProvinceChange);
    } catch (e) {
      console.log(e);
    }
  },
  onProvinceChange: function () {
    var value = document.querySelector('#_rsi-cod-form-modal-form [data-type="province_country_field"]').value;

    var html = "";

    if (!_CUSTOM_COD_FORM_PROVINCES.data[value]) {
      html += '<option value="">' + _COD_FORM_CITY_LABEL + '</option>';
      document.querySelector('#_rsi-cod-form-modal-form [data-type="city_country_field"]').innerHTML = html;
      document.querySelector('#_rsi-cod-form-modal-form [data-type="city_country_field"]').value = "";
      return;
    }

    html += '<option value="">' + _COD_FORM_CITY_LABEL + '</option>';

    Object.keys(_CUSTOM_COD_FORM_PROVINCES.data[value]).sort().forEach(function (item) {
      html += '<option value="' + item + '">' + item + '</option>';
    });

    document.querySelector('#_rsi-cod-form-modal-form [data-type="city_country_field"]').innerHTML = html;
    document.querySelector('#_rsi-cod-form-modal-form [data-type="city_country_field"]').value = "";
  }
};

function _COD_FORM_ON_OPEN_INIT_END_DEF() {
  try {
    if (typeof _COD_FORM_ON_OPEN_INIT_END_DEF_COVERAGE === "function") {
      _COD_FORM_ON_OPEN_INIT_END_DEF_COVERAGE();
    }

    var html = "";

    html += '<option value="">' + _COD_FORM_PROVINCE_LABEL + '</option>';

    Object.keys(_CUSTOM_COD_FORM_PROVINCES.data).sort().forEach(function (item) {
      html += '<option value="' + item + '">' + item + '</option>';
    });

    document.querySelector('#_rsi-cod-form-modal-form [data-type="province_country_field"]').innerHTML = html;

    _CUSTOM_COD_FORM_PROVINCES.startFields();
  } catch (e) {
    console.log(e);
  }
}

function _COD_FORM_ON_OPEN_INIT_END_EMBEDDED() {
  try {
    if (typeof _COD_FORM_ON_OPEN_INIT_END_EMBEDDED_COVERAGE === "function") {
      _COD_FORM_ON_OPEN_INIT_END_EMBEDDED_COVERAGE();
    }

    var onTimeout = function () {
      if (typeof _CUSTOM_COD_FORM_PROVINCES !== "undefined") {
        var html = "";

        html += '<option value="">' + _COD_FORM_PROVINCE_LABEL + '</option>';

        Object.keys(_CUSTOM_COD_FORM_PROVINCES.data).sort().forEach(function (item) {
          html += '<option value="' + item + '">' + item + '</option>';
        });

        document.querySelector('#_rsi-cod-form-modal-form [data-type="province_country_field"]').innerHTML = html;

        _CUSTOM_COD_FORM_PROVINCES.startFields();
      } else {
        setTimeout(onTimeout, 500);
      }
    }

    setTimeout(onTimeout, 500);
  } catch (e) {
    console.log(e);
  }
}

function _COD_FORM_ON_OPEN_INIT_END_EMBEDDED_DEF() {
  try {
    if (typeof _COD_FORM_ON_OPEN_INIT_END_EMBEDDED_DEF_COVERAGE === "function") {
      _COD_FORM_ON_OPEN_INIT_END_EMBEDDED_DEF_COVERAGE();
    }

    _COD_FORM_ON_OPEN_INIT_END_EMBEDDED();
  } catch (e) {
    console.log(e);
  }
}

var _COD_FORM_CITY_LABEL = "";
var _COD_FORM_PROVINCE_LABEL = "";

function _COD_FORM_OVERWRITE_INIT() {
  _rsi.s.form.fields.items_array.forEach(function (item) {
    if (item.type == "province_country_field" || item.type == "province") {
      item.type = "province_country_field";
      item.backendFields.name = "province";
      item.backendFields.elementType = "select";
      if (item.n) {
        if (item.n.ph) {
          _COD_FORM_PROVINCE_LABEL = item.n.ph;
        }
      }
      if (!_COD_FORM_PROVINCE_LABEL) {
        _COD_FORM_PROVINCE_LABEL = item.label;
      }
      item.backendFields.options = [{
        label: _COD_FORM_PROVINCE_LABEL,
        value: "",
      }];
    } else if (item.type == "city") {
      item.type = "city_country_field";
      item.backendFields.name = "city";
      item.backendFields.elementType = "select";
      if (item.n) {
        if (item.n.ph) {
          _COD_FORM_CITY_LABEL = item.n.ph;
        }
      }
      if (!_COD_FORM_CITY_LABEL) {
        _COD_FORM_CITY_LABEL = item.label;
      }
      var options = [{
        value: "", label: _COD_FORM_CITY_LABEL
      }];
      item.backendFields.options = options;
    }
  });

  try {
    if (typeof _COD_FORM_OVERWRITE_INIT_COVERAGE === "function") {
      if (!_COD_FORM_OVERWRITE_INIT_COVERAGE()) {
        return false;
      }
    }
  } catch (e) {
    console.log(e);
  }

  return true;
}